type BrandMarkProps = {
  compact?: boolean
}

export function BrandMark({ compact = false }: BrandMarkProps) {
  return (
    <span className="brand-mark" aria-hidden="true">
      <span className="brand-spark brand-spark-top" />
      <span className="brand-spark brand-spark-left" />
      <span className="brand-spark brand-spark-diagonal" />
      <span className="brand-tile brand-tile-accent" />
      <span className="brand-tile brand-tile-light" />
      <span className="brand-tile brand-tile-grey" />
      <span className="brand-tile brand-tile-dark" />
      {compact ? null : <span className="sr-only">DailyDrawer</span>}
    </span>
  )
}
